import type {
  ProgrammaticAdviceRecoLevel,
  ProgrammaticAdviceRecoProduct,
  ProgrammaticAdviceRecoState,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';
import type { SpartacuxDigitalAdviceState } from '@/domains/digitalAdvice/digitalAdvice.model';

export const selectProgrammaticAdviceReco = (
  state: Partial<SpartacuxDigitalAdviceState>,
): ProgrammaticAdviceRecoState | undefined =>
  state?.digitalAdvice?.recommendation;

export const selectProgrammaticAdviceRecoProducts = (
  state: Partial<SpartacuxDigitalAdviceState>,
): [ProgrammaticAdviceRecoLevel, ProgrammaticAdviceRecoProduct][] | undefined =>
  state?.digitalAdvice?.recommendation?.data;

/** Return the count of recommended products or -1 in case of error.  */
export const selectProgrammaticAdviceRecoSize = (
  state: Partial<SpartacuxDigitalAdviceState>,
): number | undefined => state?.digitalAdvice?.recommendation?.size;
